var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs__global"},_vm._l((_vm.tabs),function(tab,idx){return _c('div',{staticClass:"tab__global",style:({'border-bottom': (_vm.selectedTab==tab) ? '2px solid blue':'','font-weight': (_vm.selectedTab==tab) ? '600':''}),on:{"click":function($event){return _vm.handleSelectTab(tab, idx)}}},[_vm._v(" "+_vm._s(tab)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }